export const RESET_FORMS = 'RESET_FORMS'
export const SEND_CONTACT_MESSAGE = 'SEND_CONTACT_MESSAGE'
export const SEND_CONTACT_MESSAGE_FAILED = 'SEND_CONTACT_MESSAGE_FAILED'
export const NEWSLETTER_SUBSCRIPTION = 'NEWSLETTER_SUBSCRIPTION'
export const NEWSLETTER_SUBSCRIPTION_FAILED = 'NEWSLETTER_SUBSCRIPTION_FAILED'

export const COLLECT_BOOKING_ENQUIRY_FORMVALUES = 'COLLECT_BOOKING_ENQUIRY_FORMVALUES'
export const SUBMIT_BOOKING_ENQUIRY = 'SUBMIT_BOOKING_ENQUIRY'
export const SUBMIT_BOOKING_ENQUIRY_FAILED = 'SUBMIT_BOOKING_ENQUIRY_FAILED'